import React from "react";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import "../../../assets/MB_UBRF_3/css/MB_UBRF_3.scss";
import Header from "../../Includes/Layouts/MB_UBRF_3/Header";
import Footer from "../../Includes/Layouts/Common/Footer";
import Section1 from "../../Includes/Layouts/MB_UBRF_3/Section1";
import AccordSection from "../../Includes/Layouts/Common/AccordSection";
import FormMB_UBRF_3 from "../../Forms/FormMB_UBRF_3";
import FbViewPixel from "../../../Utility/FbViewPixel";

const MB_UBRF_3 = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="MB_UBRF_3" />
      <FbViewPixel />
      <div className="MB_UBRF_3">
        <Header />
        <section className="form-part" id="firstform">
          <div className="container nopad">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 nopad">
              <FormMB_UBRF_3 />
            </div>
          </div>
        </section>
        <Section1 />
        <AccordSection />
        <Footer />
      </div>
    </>
  );
};

export default MB_UBRF_3;
